import React, { useState, useEffect } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

import LoadingWrapper from '../components/LoadingWrapper';

import DashboardService from '../services/DashboardService';

import ITaskList from '../types/Dashboard/TaskList'

const DashboardTaskDetails: React.FC = () => {
    // Router hooks
    const location = useLocation();
    
    // Parse search params from URL
    const searchParams = new URLSearchParams(location.search);
    const entryID = searchParams.get("entryID") ?? "";

    // State
    const [tasksLoading, setTasksLoading] = useState(true);
    const [taskList, setTaskList] = useState<ITaskList>({
        formDescription: "",
        tasks: [],
    });
    const [openGroupUserModal, setOpenGroupUserModal] = useState(false);
    const [groupUsers, setGroupUsers] = useState<string[]>([]);

    // Load tasks on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        let cancelled = false;
        DashboardService.getFormSubmissionTasks(entryID)
            .then((response) => {
                if (cancelled) return;
                setTasksLoading(false);
                setTaskList(response.data);
            })
            .catch(() => {
                if (cancelled) return;
                setTasksLoading(false);
            });
        return () => { cancelled = true; };
    }, [entryID]);

    // Function to open group user modal
    const onGroupUserModal = (taskID: string) => {
        const task = taskList.tasks.find(x => x.id === taskID);

        if (task) {
            setOpenGroupUserModal(true);
            setGroupUsers(task.users);
        }
    };

    // Function to close group user modal
    const onCloseGroupUserModal = () => {
        setOpenGroupUserModal(false);
        setGroupUsers([]);
    };

    // Function to get query string for back link
    const getQueryString = () => {
        const queryString = new URLSearchParams(location.search);
        queryString.delete("entryID");
        return queryString.toString();
    };

    // Render task items
    const TaskItems = taskList.tasks.length > 0 ? 
        taskList.tasks.map((task) =>
            <tr key={task.id}>
                <td>{new Date(task.dueDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit'})}</td>
                <td>{task.description}</td>
                <td>{task.users.length > 1 ? 
                    <button onClick={() => onGroupUserModal(task.id)} className="ButtonLink">Group</button> : 
                    task.users[0]}
                </td>
                <td>{task.status}</td>
            </tr>
        ) : <tr>
                <td colSpan={100}>
                    <b>No Tasks Found</b>
                </td>
            </tr>;

    return (
        <div>
            <LoadingWrapper showLoading={tasksLoading} loadingMessage="Getting Task Details..." windSpinner windSpinnerScale={3}>
                <Modal show={openGroupUserModal} onHide={onCloseGroupUserModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Task Assigned To:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <ul>
                                {groupUsers.map((user, i) => 
                                    <li key={i}>{user}</li>
                                )}
                            </ul>
                        </div>
                    </Modal.Body>
                </Modal>

                <Link to={{pathname: '/dashboard', search: `?${getQueryString()}`} }>Go Back</Link>
                <h1 className="header mt-5 text-center">Task Details</h1>
                <div className="ComponentDivs">
                    <b>Form Description: </b>{taskList.formDescription}
                </div>
                <div>
                    <Table>
                        <thead>
                            <tr>
                                <th style={{width: 75}}>Due Date</th>
                                <th style={{width: 275}}>Task Description</th>
                                <th style={{width: 125}}>Assigned To</th>
                                <th style={{width: 125}}>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {TaskItems}
                        </tbody>
                    </Table>
                </div>
            </LoadingWrapper>
        </div>
    );
};

export default DashboardTaskDetails;